/* eslint-disable */
import React from 'react';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import './DomainTileDropdown.css'; // Assuming CSS
import NewInfoIcon from '../../ProcureToPayComp/TileComp/NewInfoIcon';

const DomainTileDropdown = ({
    title = "Title",
    costValue,
    setCostValue,
    costOptions,
    showButton = false,
    path,
    detailState,
    infoIcondata=""
}) => {
    const history = useHistory();

    // const handleDetailClick = () => {
    //     history.push(path);
    // };

    const handleDetailClick = () => {
        if (path) {
          history.push(path, detailState);
        }
      };

    return (
        <div>
        <div className="domain-tile">
            <div className="domain-tile-header">{title}</div>

            <div className="tile-content">
                <div className="filter_panel_col">
                    <div className="filter_select_wrapper_50">
                        <Select
                            value={costValue}
                            onChange={setCostValue}
                            options={costOptions}
                            isSearchable={false}
                        />
                    </div>
                </div>

                {showButton && (
                    <button
                        className="detail-view-btn"
                        onClick={handleDetailClick}
                    >
                        Detailed View <span className="arrow">»</span>
                    </button>
                )}

          {infoIcondata &&
            <div className='ml-2' style={{ position: "relative", overflow: "visible", zIndex: 50, }}>
              <NewInfoIcon popupContent={infoIcondata} />
            </div>
          }

                
            </div>
        </div>
    </div>
    );
};

export default DomainTileDropdown;